{
    "RestNoContentError": "Der Antwortinhalt wurde erwartet, aber keiner wurde gegeben",
    "RestJsonProcessing": "Fehler bei der Verarbeitung von JSON",
    "NAME": "LanguageErrors",
    "UnhandlableError": "Der Akixi-Dienst hat einen nicht behebbaren Fehler gemeldet.",
    "UnknownError": "Es ist ein unbekannter Serverfehler aufgetreten",
    "InvalidCmeId": "Ungültige CME-ID"
}